import type { PresentationIsEmptyProps } from '../../'

export default function isEmpty(_: PresentationIsEmptyProps) {
  return false
}
